import { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Building2, CreditCard, DollarSign, Users, Settings, LogOut, MessageCircle } from 'lucide-react';
import { authAPI } from '../../api';
import Logo from '../../components/Logo';

export default function SuperAdminLayout() {
  const location = useLocation();
  const [darkMode] = useState(() => localStorage.getItem('darkMode') === 'true');

  const menuItems = [
    { path: '/super-admin', icon: LayoutDashboard, label: 'Dashboard', exact: true },
    { path: '/super-admin/companies', icon: Building2, label: 'Empresas' },
    { path: '/super-admin/subscriptions', icon: CreditCard, label: 'Assinaturas' },
    { path: '/super-admin/financial', icon: DollarSign, label: 'Financeiro' },
    { path: '/super-admin/users', icon: Users, label: 'Criar Admins' },
    { path: '/super-admin/conversations', icon: MessageCircle, label: 'Conversas', badge: true },
  ];

  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  const handleLogout = () => {
    if (confirm('Deseja sair do Painel Super Admin?')) {
      authAPI.logout();
      window.location.href = '/login';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      {/* Sidebar */}
      <div className="fixed left-0 top-0 h-full w-64 bg-gradient-to-b from-purple-900 to-blue-900 text-white shadow-2xl z-40">
        {/* Logo */}
        <div className="p-6 border-b border-white/10">
          <div className="flex items-center gap-3 mb-2">
            <Logo size="md" />
            <div>
              <h1 className="text-xl font-black">P-TechAI</h1>
              <p className="text-xs text-purple-200">Super Admin Panel</p>
            </div>
          </div>
        </div>

        {/* Menu */}
        <nav className="p-4 space-y-2">
          {menuItems.map(item => {
            const Icon = item.icon;
            const active = isActive(item.path, item.exact);
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                  active
                    ? 'bg-white/20 text-white shadow-lg'
                    : 'text-purple-100 hover:bg-white/10'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/10">
          <Link
            to="/dashboard"
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-purple-100 hover:bg-white/10 transition-colors mb-2"
          >
            <Settings className="w-4 h-4" />
            <span className="text-sm">Voltar ao Sistema</span>
          </Link>
          
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-4 py-2 rounded-lg text-red-300 hover:bg-red-500/20 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            <span className="text-sm">Sair</span>
          </button>
        </div>
      </div>

      {/* Conteúdo */}
      <div className="ml-64">
        {/* Header */}
        <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-30">
          <div className="px-6 py-4">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                  Painel Super Admin
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Gestão completa do sistema EstoqueProAI
                </p>
              </div>

              <div className="flex items-center gap-3">
                <div className="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 rounded-lg shadow-lg">
                  <p className="text-xs text-white/80">Você é o</p>
                  <p className="text-sm font-bold text-white">👑 Super Admin</p>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}


